import { DateTime } from 'luxon';

export default class DateUtils {
   static IsoDateFormat = 'yyyy-MM-dd';
   static IsoDateTimeFormat = 'yyyy-MM-dd TT';

   static parseDateStringToLocalStringFormat(
      value: unknown,
      includeTime = false,
      isUtc = false,
      currentPropertyTimezone: string
   ) {
      const formattedDate = DateUtils.parseDateToDateTimeInPropertyTimeZone(
         value,
         includeTime,
         isUtc,
         currentPropertyTimezone
      );
      if (formattedDate == null) {
         return '';
      }
      if (includeTime) {
         return formattedDate.toLocaleString(DateTime.DATETIME_SHORT);
      }
      return formattedDate.toLocaleString(DateTime.DATE_SHORT);
   }

   static parseDateToDateTimeInPropertyTimeZone(
      value: unknown,
      includeTime = false,
      isUtc = false,
      currentPropertyTimezone: string
   ): DateTime | null {
      let formattedDate = null;

      let timeZoneId = 'Australia/Sydney';
      if (isUtc) {
         timeZoneId = 'UTC';
      }
      if (value instanceof DateTime) {
         formattedDate = value.setZone(currentPropertyTimezone);
      } else if (value instanceof Date) {
         formattedDate = DateTime.fromJSDate(value, {
            zone: timeZoneId
         }).setZone(currentPropertyTimezone);
      } else if (typeof value === 'string') {
         let format = DateUtils.IsoDateFormat;
         if (includeTime) {
            format = DateUtils.IsoDateTimeFormat;
         }

         formattedDate = DateTime.fromFormat(value, format, {
            zone: timeZoneId
         });
         if (!formattedDate.isValid) {
            //Alt format as a quick fix for current issues till we update backend
            format = 'MM/dd/yyyy TT';
            formattedDate = DateTime.fromFormat(value, format, {
               zone: timeZoneId
            });
            if (!formattedDate.isValid) {
               formattedDate = DateTime.fromISO(value, { zone: timeZoneId });
            }
         }

         formattedDate = formattedDate.setZone(currentPropertyTimezone);
      }
      return formattedDate;
   }

   static convertLocalDateTimeToUtcIsoString(
      value: DateTime,
      propertyTimeZone: string
   ): string | null {
      const formattedDate = value.setZone(propertyTimeZone);

      const utcDate = formattedDate.setZone('utc');
      return utcDate.toISODate();
   }

   static convertLocalDateStringToUtcIsoString(
      value: string,
      propertyTimeZone: string
   ): string | null {
      const formattedDate = DateTime.fromFormat(value, DateUtils.IsoDateFormat, {
         zone: propertyTimeZone
      });
      const utcDate = formattedDate.setZone('utc');
      return utcDate.toISODate();
   }
}
